import {ClientsStatusesModel} from "./clients.statuses.model";
import {makeAutoObservable} from "mobx";
import AppStore from "../../../app.store";
import axios from "axios";
import {api} from "../../../api/endpoints";
import {toast} from "react-toastify";

const loadingInitialState: boolean = false;
const statusesInitialState: ClientsStatusesModel[] = [];

class ClientsStatusesStore {
    public clientStatuses = statusesInitialState;
    public clientStatusesLoading = loadingInitialState;
    public deleteStatusLoading = loadingInitialState;
    public setDefaultStatusLoading = loadingInitialState;

    constructor() {
        makeAutoObservable(this)
    }

    private setLoading(loading: boolean) {
        this.clientStatusesLoading = loading;
    }

    private setStatuses(data: any) {
        const {statuses} = data;
        this.clientStatuses = statuses;
    }

    private setDeleteStatusLoading(loading: boolean) {
        this.deleteStatusLoading = loading;
    }

    private setSetDefaultStatusLoading(loading: boolean) {
        this.setDefaultStatusLoading = loading;
    }

    private getHeaders = () => {
        const {getToken} = AppStore;
        return {Authorization: `Bearer ${getToken()}`};
    }

    public clientStatusesPageInit = async (signal: AbortSignal) => {
        await this.getClientStatusesReq(signal);
    }

    public getClientStatusesReq = async (signal?: AbortSignal) => {
        this.setLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.get(api.client_statuses, {headers, signal});
            this.setStatuses(response?.data);
            return response;
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    public deleteClientStatusReq = async (statusID: number) => {
        this.setDeleteStatusLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.delete(api.client_statuses + `/${statusID}`, {headers});
            toast.success(response?.data?.message);
            return response;
        } catch (e: any) {
            toast.error(e?.response?.data?.reason);
        } finally {
            this.setDeleteStatusLoading(false);
            await this.getClientStatusesReq();
        }
    }

    public setDefaultClientStatusReq = async (statusID: number) => {
        this.setSetDefaultStatusLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.put(api.client_statuses + `/default/${statusID}`, {}, {headers});
            toast.success(response?.data?.message);
            return response;
        } catch (e: any) {
            toast.error(e?.response?.data?.reason);
        } finally {
            this.setSetDefaultStatusLoading(false);
            await this.getClientStatusesReq();
        }
    }
}

export default new ClientsStatusesStore();